import { Toaster } from "sonner";

export function AppToaster() {
	return (
		<Toaster
			className="toaster"
			richColors
			position="top-left"
			style={{
				zIndex: 1500,
				isolation: "isolate",
			}}
		/>
	);
}
